var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-overlay", { attrs: { show: _vm.is_load, rounded: "sm" } }, [
        _c("div", { staticClass: "panel-tag" }, [
          _vm._v("\n\t\t\t" + _vm._s(_vm.__t("CATEG_TAG_PUBLISH")) + "\n\t\t"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group mt-2" }, [
          _c(
            "label",
            { staticClass: "form-label", attrs: { for: "advanced_name" } },
            [
              _vm._v(
                "\n\t\t\t\t" + _vm._s(_vm.__t("CATEG_RENAME")) + "\n\t\t\t"
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "input-group flex-nowrap" }, [
            _c("div", { staticClass: "input-group-prepend" }, [
              _c("span", { staticClass: "input-group-text" }, [
                _c("i", { staticClass: "fal fa-typewriter fs-xl" }),
              ]),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.categ.adv_name,
                  expression: "categ.adv_name",
                },
              ],
              staticClass: "form-control",
              attrs: { id: "advanced_name", type: "text" },
              domProps: { value: _vm.categ.adv_name },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.categ, "adv_name", $event.target.value)
                },
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group mt-2" }, [
          _c(
            "label",
            { staticClass: "form-label", attrs: { for: "advanced_name" } },
            [
              _vm._v(
                "\n\t\t\t\t" + _vm._s(_vm.__t("CATEG_ORDERING")) + "\n\t\t\t"
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "input-group flex-nowrap" }, [
            _c("div", { staticClass: "input-group-prepend" }, [
              _c("span", { staticClass: "input-group-text" }, [
                _c("i", { staticClass: "fal fa-typewriter fs-xl" }),
              ]),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.categ.ordering,
                  expression: "categ.ordering",
                },
              ],
              staticClass: "form-control",
              attrs: { id: "ctg_ordering", type: "number" },
              domProps: { value: _vm.categ.ordering },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.categ, "ordering", $event.target.value)
                },
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group mt-2" }, [
          _c(
            "label",
            { staticClass: "form-label", attrs: { for: "organization" } },
            [
              _vm._v(
                "\n\t\t\t\t" + _vm._s(_vm.__t("ORGANIZATION")) + "\n\t\t\t"
              ),
            ]
          ),
          _vm._v(" "),
          _vm.organizations.length > 0
            ? _c(
                "div",
                {},
                [
                  _c(
                    "v-select",
                    {
                      staticClass: "imc_reasons",
                      attrs: {
                        label: "title",
                        options: this.organizations,
                        filterable: false,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "option",
                            fn: function (option) {
                              return [
                                _c("div", { staticClass: "d-center" }, [
                                  _c("div", [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(option.title) +
                                        "\n\t\t\t\t\t\t\t\t"
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "small badge border border-info text-info mr-1",
                                      },
                                      [_vm._v(" " + _vm._s(option.provider))]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _c("small", [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(option.uniq_id) +
                                          "\n\t\t\t\t\t\t\t\t"
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        812497343
                      ),
                      model: {
                        value: _vm.active_org,
                        callback: function ($$v) {
                          _vm.active_org = $$v
                        },
                        expression: "active_org",
                      },
                    },
                    [
                      _c("template", { slot: "no-options" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(_vm.__t("CHOICE_ORG")) +
                            "\n\t\t\t\t\t"
                        ),
                      ]),
                    ],
                    2
                  ),
                ],
                1
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("h5", { staticClass: "frame-heading" }, [
          _vm._v(_vm._s(_vm.__t("PUBLISHED_TTL"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "custom-control custom-checkbox custom-control-inline",
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.categ.published,
                  expression: "categ.published",
                },
              ],
              staticClass: "custom-control-input",
              attrs: { type: "checkbox", id: "publish" },
              domProps: {
                checked: Array.isArray(_vm.categ.published)
                  ? _vm._i(_vm.categ.published, null) > -1
                  : _vm.categ.published,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.categ.published,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 &&
                        _vm.$set(_vm.categ, "published", $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        _vm.$set(
                          _vm.categ,
                          "published",
                          $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                        )
                    }
                  } else {
                    _vm.$set(_vm.categ, "published", $$c)
                  }
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "custom-control-label",
                attrs: { for: "publish" },
              },
              [_vm._v(_vm._s(_vm.__t("PUBLISHED")))]
            ),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "skeep_sync mt-5" }, [
          _c("h5", { staticClass: "frame-heading" }, [
            _vm._v(_vm._s(_vm.__t("SKEEP_TTL"))),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "custom-control custom-checkbox custom-control-inline",
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.categ.skeep_sync,
                    expression: "categ.skeep_sync",
                  },
                ],
                staticClass: "custom-control-input",
                attrs: { type: "checkbox", id: "skeep_sync" },
                domProps: {
                  checked: Array.isArray(_vm.categ.skeep_sync)
                    ? _vm._i(_vm.categ.skeep_sync, null) > -1
                    : _vm.categ.skeep_sync,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.categ.skeep_sync,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(_vm.categ, "skeep_sync", $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.categ,
                            "skeep_sync",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.categ, "skeep_sync", $$c)
                    }
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "custom-control-label",
                  attrs: { for: "skeep_sync" },
                },
                [_vm._v(_vm._s(_vm.__t("SKEEP_SYNC")))]
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _vm.categ.published
          ? _c("div", { staticClass: "providers" }, [
              _c("h5", { staticClass: "frame-heading mt-4" }, [
                _vm._v(_vm._s(_vm.__t("PUBLISHED_TTL_PROV"))),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "frame-wrap" },
                _vm._l(_vm.providers_services, function (prov) {
                  return _c(
                    "div",
                    {
                      key: prov.id,
                      staticClass:
                        "custom-control custom-checkbox custom-control-inline",
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: prov.is_on,
                            expression: "prov.is_on",
                          },
                        ],
                        staticClass: "custom-control-input",
                        attrs: { type: "checkbox", id: prov.type },
                        domProps: {
                          checked: Array.isArray(prov.is_on)
                            ? _vm._i(prov.is_on, null) > -1
                            : prov.is_on,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = prov.is_on,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(prov, "is_on", $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    prov,
                                    "is_on",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(prov, "is_on", $$c)
                            }
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "custom-control-label",
                          attrs: { for: prov.type },
                        },
                        [_vm._v(_vm._s(prov.human_name))]
                      ),
                    ]
                  )
                }),
                0
              ),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }